var SurveyPromptConfig = require("lib/survey/SurveyPromptConfig.js");
var CurrentUser = require("lib/account/CurrentUser");
var Spinner = require("components/utility/Spinner");

var Glyphicon = require("components/utility/icons/Glyphicon");

require("survey/survey_prompt.scss");

class SurveyPromptDisplay extends React.Component {
  constructor(props) {
    super();
    autobind(this);

    this.state = {
      answered: false,
      sidebarCollapsed: false,
      showFreeResponse: false,
      loading: false,
      selectedOptions: [],
      selectedOp: null
    }
  }
  // for a given answer, should free response show?
  freeResponsePrompts(answer) {
    var { prompt } = this.props
    
    if (prompt.include_free_response && answer == 'Other') {
      return true
    } else if (prompt.explain_answer && _.includes(prompt.explain_answer, answer)) {
      return true
    } else {
      return false
    }
  }

  sendResponseData(answer) {
    this.setState({ loading: true })
    sessionStorage.removeItem(SurveyPromptConfig.PROMPT_SESSION_KEY)

    var feedbackItem = {
      user_id: CurrentUser.get().id,
      subject_type: 'survey',
      subject_id: this.props.prompt.id,
      key: this.props.prompt.key,
      reaction: answer,
      subject_data: this.props.dataPacket || {}
    }
    var params = { feedback_item: feedbackItem };

    CurrentUser.api().postFeedbackItem(params, $wr.apiHandler(function (serverResponse) {
      // for LO
      LuckyOrangeClient.tagComponent(`SurveyPrompt Submitted: ${this.props.prompt.id}`);
      this.setState({ loading: false })
      console.log('Server Response', serverResponse)

      if (serverResponse.feedback_item) {
        this.showSuccessMessage()
        this.props.onSubmitFeedback()
      } else {
        LuckyOrangeClient.tagComponent(`SurveyPrompt Failed: ${this.props.prompt.id}`);
        this.showFailMessage('Oops! Something went wrong and the feedback was no recorded.')
      }
    }.bind(this)))
  }

  showSuccessMessage() {
    this.setState({ answered: true })

    window.wrNotifications.triggerDropDownNotification({
      title: "Thank you for your feedback!",
      icon: "ok-circle",
    });
  }

  showFailMessage(message) {
    window.wrNotifications.triggerDropDownNotification({
      title: message,
      icon: "exclamation-sign", type: "error"
    });
  }

  handleClick(answer) {
    var prompt = this.props.prompt

    if (this.freeResponsePrompts(answer)) {
      this.setState({ showFreeResponse: !this.state.showFreeResponse })
    }

    if (!this.freeResponsePrompts(answer) && !prompt.select_multiple) {
      // send response data to BE
      this.sendResponseData(answer)
    } else {
      if (prompt.select_multiple) {
        var oldOps = _.clone(this.state.selectedOptions)
        var newOps = _.includes(oldOps, answer) ? _.filter([...oldOps], (o) => o !== answer) : [...oldOps, answer]
      } else {
        var newOps = [answer]
      }
      
      this.setState({ selectedOptions: newOps })
    }
  }

  handleSubmit(e) {
    $wr.nope(e);

    var { selectedOptions } = this.state
    var fRAnswer = e.target.freeResponseAnswer.value

    var answer = _.map(selectedOptions, op => {
      return this.freeResponsePrompts(op) ? `${op}: ${fRAnswer}` : op
    })

    this.sendResponseData(answer.join(' && '))
  }

  renderOptionButtons() {
    var prompt = this.props.prompt

    var animationClass = prompt.style.circle_animation ? 'spin circle' : ''
    if (prompt.options) {
      return _.map(prompt.options, (option) => {
        var selectedClass = this.state.selectedOp == option ? 'selected' : ''
        return (
          <button className={`surveyOptionBtn ${animationClass} ${selectedClass}`} key={option} onClick={() => this.handleClick(option)}>{option}</button>
        )
      })
    }
  }

  renderOptionRadios() {
    var prompt = this.props.prompt
    if (prompt.options) {

      if (prompt.include_free_response && !_.include(prompt.options, 'Other')) {
        var options = [...prompt.options, 'Other']
      } else {
        var options = [...prompt.options]
      }

      var animationClass = prompt.style.circle_animation ? 'spin circle' : ''

      return _.map(options, (option) => {
        if (option == 'Other') {
          var freeResponse = (
            <textarea name="freeResponseAnswer" className={`freeResponseAnswer ${this.state.showFreeResponse ? 'showTextArea' : ''}`} rows="2" cols="20"></textarea>
          )
        }
        return (
          <span key={option}>
            <input
              className={`surveyOptionBtn ${animationClass}`}
              type="radio"
              checked={_.includes(this.state.selectedOptions, option)}
              readOnly
              onClick={() => this.handleClick(option)}
              value={option}
            /> <p className='optionLabel'>{option}</p>
            {freeResponse}
          </span>
        )
      })
    }
  }

  renderEmbededContentLayout(prompt) {
    if (this.state.showFreeResponse) {
      var freeResponse = (
        <form onSubmit={this.handleSubmit}>
          <div className="freeResponse">
            <div className="freeResponsePrompt">Please explain your answer</div>
            <textarea name="freeResponseAnswer" className='freeResponseAnswer' rows="2" cols="20"></textarea>
            <div className="submitBtn">
              <button className='btn btn-primary' type='submit'>Submit</button>
            </div>
          </div>
        </form>
      )
    }
    return (
      <div className='embededContentInner'>
        <Glyphicon icon={'glyphicon glyphicon-comment'} className={'commentIcon'} />
        <div className='promptBody'>{prompt.body}</div>
        <div className='promptOptions'>{this.renderOptionButtons()}</div>
        {freeResponse}
      </div>
    )
  }

  toggleSidebar(e) {
    $wr.nope(e)
    this.setState({ sidebarCollapsed: !this.state.sidebarCollapsed }, () => {
      if (this.state.sidebarCollapsed == true) {
        $('.surveyPromptContainer').addClass('hideSidebar').removeClass('showSidebar')
      } else {
        $('.surveyPromptContainer').addClass('showSidebar').removeClass('hideSidebar')
      }
    })
  }

  renderSidebarSurveyLayout(prompt) {
    var arrowIcon = this.state.sidebarCollapsed ? 'glyphicon glyphicon-chevron-left' : 'glyphicon glyphicon-chevron-right'
    var submitBtn = _.size(this.state.selectedOptions) > 0 ? <button type='submit'>Submit</button> : ''

    if (this.state.loading && submitBtn !== '') {
      submitBtn = <Spinner placeholder={true} scale={1.2} />
    }

    return (
      <div className={`sidebarSurveyInner ${this.state.sidebarCollapsed == true ? 'hideSidebar' : 'showSidebar'}`}>
        <div className={`promptBody`}>
          <Glyphicon icon={arrowIcon} className={`promptBodyArrow arrow`} onClick={this.toggleSidebar} />
          <div className='promptBodyText'>
            {prompt.body}
            <div className="promptDescription">{prompt.description}</div>
          </div>
        </div>
        <div className={`promptOptions`}>
          <form onSubmit={this.handleSubmit}>
            {this.renderOptionRadios()}
            {submitBtn}
          </form>
        </div>

      </div>
    )
  }

  renderSurveyPrompt() {
    if (!this.state.answered) {

      var prompt = this.props.prompt
      var layouts = SurveyPromptConfig.LAYOUTS

      switch (prompt.layout) {
        case layouts.EMBEDED_CONTENT:
          return this.renderEmbededContentLayout(prompt)
        case layouts.SIDEBAR_SURVEY:
          return this.renderSidebarSurveyLayout(prompt)
      }
    }
  }

  render() {
    return (
      <div>
        {this.renderSurveyPrompt()}
      </div>
    );
  }
};

SurveyPromptDisplay.propTypes = StrictPropTypes({
  admin: PropTypes.object,
  userID: PropTypes.number,
  prompt: PropTypes.object,
  dataPacket: PropTypes.object,
  onSubmitFeedback: PropTypes.func
});

module.exports = SurveyPromptDisplay;



// WEBPACK FOOTER //
// ./modules/components/survey/SurveyPromptDisplay.js